import { render, staticRenderFns } from "./MainSiteLayout.vue?vue&type=template&id=12ee0a60&scoped=true"
import script from "./MainSiteLayout.vue?vue&type=script&lang=js"
export * from "./MainSiteLayout.vue?vue&type=script&lang=js"
import style0 from "./MainSiteLayout.vue?vue&type=style&index=0&id=12ee0a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee0a60",
  null
  
)

export default component.exports